import {ScrollView} from 'react-native-gesture-handler';
import {RFValue} from 'react-native-responsive-fontsize';

import styled from 'styled-components/native';

interface ISelectFilter {
  selected?: boolean;
}
export const Container = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  flex: 1;
`;
export const ContentTitles = styled.View`
  padding: 0 24px;
`;
export const FiltersContainer = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const TextChoice = styled.Text`
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(10)}px;
  margin-top: ${RFValue(20)}px;
  font-family: ${({theme}) => theme.fonts.bold};
`;

//@ts-ignore
export const ButtonsCategory = styled(ScrollView).attrs({
  horizontal: true,
  showsHorizontalScrollIndicator: false,
  contentContainerStyle: {paddingRight: 18, paddingLeft: 24},
})`
  width: 100%;
  flex-direction: row;
`;

export const ButtonCategory = styled.TouchableOpacity<ISelectFilter>`
  align-items: center;
  justify-content: center;
  padding: ${RFValue(6)}px ${RFValue(12)}px;
  margin-top: ${RFValue(5)}px;
  margin-right: ${RFValue(6)}px;

  border-radius: 30px;
  background-color: ${props =>
    props.selected
      ? props.theme.colors.primary
      : props.theme.colors.background_black};
`;
export const ButtonCategoryText = styled.Text<ISelectFilter>`
  color: ${props =>
    props.selected ? props.theme.colors.shape : props.theme.colors.text_dark};
  font-family: ${props =>
    props.selected ? props.theme.fonts.semibold : props.theme.fonts.regular};
`;

export const Content = styled.View`
  padding: 0 24px;
  flex: 1;
`;

export const ItemContainer = styled.View`
  border-radius: 10px;
  margin-bottom: ${RFValue(12)}px;
  margin-top: ${RFValue(5)}px;
`;
export const ItemName = styled.Text`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
`;
export const ItemDescription = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.regular};
  padding: 0 10px;
`;

export const FiltersText = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
  padding: 0 24px;
`;
